import { Layout } from 'antd';
import styled from 'styled-components';

export const PublicLayoutStyle = styled(Layout)`
  width: 100%;
  height: 100%;
`;
